export default "__VITE_ASSET__EUxZPzWm__"